'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import * as TooltipPrimitive from '@radix-ui/react-tooltip'

export type HelpContent =
  | string
  | {
      title: string
      message: string
    }

export function TooltipContent({ help }: { help: HelpContent }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content side="top" sideOffset={6} className="z-50">
        <div className="border-default bg-default text-high-emphasis typography-body-xs-normal relative flex max-w-[60ch] flex-col gap-0.5 rounded-sm border p-3 drop-shadow-sm">
          {typeof help === 'string' ? (
            <HelpMessage>{help}</HelpMessage>
          ) : (
            <>
              <HelpTitle>{help.title}</HelpTitle>
              <HelpMessage>{help.message}</HelpMessage>
            </>
          )}
        </div>
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

function HelpMessage({ children }: { children: string }) {
  return <span className="typography-body-xs-normal">{children}</span>
}

function HelpTitle({ children }: { children: string }) {
  return <span className="typography-body-xs-bold">{children}</span>
}
